var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "project-docs-reject-history clearfix",
      class: { "first-record": _vm.showRejectHeader },
    },
    [
      _c("div", { staticClass: "row clearfix" }, [
        _c("div", { staticClass: "medium-2 column rejected-date" }, [
          _vm.showRejectHeader
            ? _c(
                "div",
                { staticClass: "uppercase-bold bottom-margin reject-header" },
                [_vm._v(_vm._s(_vm.$t("date")))]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "reject-detail" }, [
            _c("span", [_vm._v(_vm._s(_vm.formatDate(_vm.item.updatedAt)))]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "medium-1 column rejected-by" }, [
          _vm.showRejectHeader
            ? _c(
                "div",
                { staticClass: "uppercase-bold bottom-margin reject-header" },
                [_vm._v(_vm._s(_vm.$t("project.docs.action")))]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "reject-detail" }, [
            _c("span", { staticStyle: { "text-transform": "capitalize" } }, [
              _vm._v(_vm._s(_vm.item.actionType)),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "medium-2 column rejected-by" }, [
          _vm.showRejectHeader
            ? _c(
                "div",
                { staticClass: "uppercase-bold bottom-margin reject-header" },
                [_vm._v(_vm._s(_vm.$t("actionBy")))]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "reject-detail" }, [
            _c("span", { staticStyle: { "text-transform": "capitalize" } }, [
              _vm._v(_vm._s(_vm.item.approver.name)),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "medium-5 column reject-comment" }, [
          _vm.showRejectHeader
            ? _c(
                "div",
                { staticClass: "uppercase-bold bottom-margin reject-header" },
                [_vm._v(_vm._s(_vm.$t("comment")))]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "reject-detail reject-reason" }, [
            _vm._v(_vm._s(_vm.item.detail && _vm.item.detail.rejectReason)),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "medium-2 column show-more-link uppercase-bold" },
          [
            _vm.showRejectHeader
              ? _c(
                  "div",
                  {
                    staticClass: "uppercase-bold bottom-margin reject-header",
                    staticStyle: { "padding-right": "10px" },
                  },
                  [_vm._v(_vm._s(_vm.$t("project.docs.attachment")))]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "a",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showAttachments && _vm.showDetailsLink(_vm.item),
                    expression: "showAttachments && showDetailsLink(item)",
                  },
                ],
                staticClass: "reject-detail",
                on: {
                  click: function ($event) {
                    _vm.showAttachments = false
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("action.showLess")))]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      !_vm.showAttachments && _vm.showDetailsLink(_vm.item),
                    expression: "!showAttachments && showDetailsLink(item)",
                  },
                ],
                staticClass: "reject-detail",
                on: {
                  click: function ($event) {
                    _vm.showAttachments = true
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("action.showMore")))]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showAttachments,
              expression: "showAttachments",
            },
          ],
          staticClass: "clearfix",
        },
        [
          _c("EditAttachments", {
            attrs: { sourceId: _vm.item.id, canDowloadAll: _vm.isContractor },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }